import React from 'react';
import { IconedButton } from 'components/IconedButton';
import CW from '../images/coverwhale_logo_white.png';

const TicketIssues = ({
  ticketData,
  handleIssueChange,
  selectedIssues,
  handleNextClick,
  ticketIssue,
}) => {
  return (
    <div className="w-full mx-auto bg-white">
      <header className="bg-black flex items-center justify-between px-4 pb-2 pt-2">
        <img src={CW} alt="Cover Whale" className="w-[360px]" />
      </header>

      <div className="flex-col border rounded p-4 mt-4 pt-0 border-slate-300 mx-6">
        <div className="flex justify-between py-2 border-b border-slate-300">
          <div>Ticket Number</div>
          <div>{ticketData.ticketNumber}</div>
        </div>
        {ticketData.companyName && (
          <>
            <div className="flex justify-between py-2 border-b border-slate-300">
              <div>Company Name</div>
              <div>{ticketData.companyName}</div>
            </div>
            <div className="flex justify-between pt-2">
              <div>Company Email</div>
              <div>{ticketData.assignedUserEmail}</div>
            </div>
          </>
        )}
      </div>

      <div className="p-4 pl-6 mt-4 pt-0">
        Select issues that need to be addressed:
      </div>

      <div className="flex-col border rounded p-4 pt-0 border-slate-300 mx-6">
        {ticketIssue.map((issue, index) => (
          <div
            key={index}
            className="flex justify-between py-2 border-b border-slate-300"
          >
            <div>{issue.value}</div>
            <input
              type="checkbox"
              checked={selectedIssues.some(
                (i) => i.value === issue.value
              )}
              onChange={() => handleIssueChange(issue.value)}
            />
          </div>
        ))}
      </div>

      <div className="p-4 mt-4 pt-0">
        <div className="w-full flex items-center">
          <IconedButton
            size="1500px"
            color="#d32425"
            textColor="white"
            text="Next"
            action={() => handleNextClick()}
          />
        </div>
      </div>
    </div>
  );
};

export default TicketIssues;
